import { getValidationMessage } from "../../utils/i18nHelper";
import { validationMessages } from "./validationOpt";

const mixNameReg = /^[^\{\}\[\]\(\)]*$/;

export const getTrackNameValidators = (lang) => {
    let trackNameValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'trackName', 'required', lang)
            },
        }
    };
    return trackNameValidators;
};

export  const getTrackMixNameValidators = (lang) => {
    let trackMixNameValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'trackMixName', 'required', lang)
            },
            regexp: {
                regexp: mixNameReg,
                message: getValidationMessage(validationMessages, 'trackMixName', 'regexp', lang),
            },
        }
    };
    return trackMixNameValidators;
};

export const getArtistNameValidators = (lang) => {
    let artistNameValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'artistName', 'required', lang)
            },
        }
    };
    return artistNameValidators;
};
  
export const getArtistTypeValidators = (lang) => {
    let artistTypeValidators = {
        validators: {
            notEmpty: {
                message: getValidationMessage(validationMessages, 'artistType', 'required', lang)
            },
        }
    };
    return artistTypeValidators;
};